const d3 = require('d3');
// const { differenceEuclideanRGB } = require('d3-color-difference');

exports.isGray = (color) => {
  const { h, s, l } = d3.hsl(color);
  const ret = !(h && s > 0.15 && l > 0.1 && l < 0.95);
  return ret;
};
